import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_emoji-4",
  "use": "svg_emoji-4-usage",
  "viewBox": "0 0 28 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 25\" id=\"svg_emoji-4\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.487 13.83c1 3.765 4.438 6.546 8.513 6.546s7.513-2.781 8.513-6.546H5.487ZM14 24.896C6.653 24.896.674 18.918.674 11.57V9.31h26.651v2.26c0 7.347-5.978 13.325-13.325 13.325ZM6.013 3.134a2.673 2.673 0 1 1-5.347 0 2.673 2.673 0 0 1 5.347 0Zm21.32 0a2.673 2.673 0 1 1-5.346 0 2.673 2.673 0 0 1 5.346 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol